import { render } from "./AppSidebar.vue?vue&type=template&id=468939a2&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=468939a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-468939a2"

export default script